import { ReactNode } from 'react';

export interface RouteItem {
  path: string;
  element: ReactNode;
  label?: string;
  icon?: string;
  children?: RouteItem[];
}

export interface MenuSection {
  label: string;
  routes: RouteItem[];
}

export const PATHS = {
  LOGIN: '/login',
  DASHBOARD: '/',
  FINANCE: '/finances',
  DETAILS_GRANT: '/finances/details-grant',
  EX_PREMIUM: '/finances/ex-premium',
  USERS: '/users',
  CLASSES: '/classes',
  LESSONS: '/lessons',
  GENERATOR: '/lessons/:lessonId/generator',
  TIPS: '/tips',
  MODULES: '/lessons/:lessonId/new-module',
  MODULE: '/lessons/:moduleId/update-module',
  TESTS: '/tests',
  LESSON_QUIZZ: '/lessons/:lessonId/quizz',
  MODULE_QUIZZ: '/lessons/:lessonId/module/:moduleId/quizz',
  EVALUATION: '/lessons/:lessonId/evaluation',
  EXAMS: '/exams',
  SCHOOLS: '/schools',
  GIFTS: '/gifts',
  OFERS: '/offers',
  COMPANY: '/companies',
  FAQ: '/faq',
  B2B_FINANCE: '/finances-b2b',
  BLANK_EXAM: '/examen-blanc',
  SETTING_UP_TESTS: '/examen-blanc/configuration-epreuves',
  ESTABLISHMENTS: '/establishments',
  SOCIUM: '/socium',
  SOCIUM_DETAIL: '/socium/:integrationId',
  DISCIPLINES: '/disciplines',
} as const;

export type PathsType = (typeof PATHS)[keyof typeof PATHS];
